import React, { useContext } from "react";

import {
  AlertModal,
  AlertModalBody,
  AlertModalButton,
  AlertModalFooter,
  AlertModalHeading,
} from "@braze/beacon-commons";

import { StackOrder } from "@lib/canvasStackOrder";

import { AsyncConfirmationModalContext } from "../AsyncConfirmationModalContext";

export const AsyncConfirmationModalWithIntent = (): React.ReactElement | null => {
  const { state, activeModal, handleCancel, handleOk, handleTertiary } = useContext(AsyncConfirmationModalContext);

  if (!activeModal) {
    return null;
  }

  return (
    <AlertModal
      className="confirmation-modal bcl-ignore-click-outside"
      isOpen={state.isOpen}
      toggle={handleCancel(activeModal.id)}
      intent={activeModal.intent ?? "info"}
      size={activeModal.size}
      ignoreOutsideClick
      hideCloseButton
      zIndex={activeModal.zIndex ?? StackOrder.OVERLAY_CONTENT_ABOVE_POPOVER}
    >
      {activeModal.heading && <AlertModalHeading>{activeModal.heading}</AlertModalHeading>}
      <AlertModalBody className="confirmation-modal_body">{activeModal.body}</AlertModalBody>
      <AlertModalFooter className="confirmation-modal_footer">
        {activeModal.tertiaryText && (
          <AlertModalFooter aligner side="left">
            <AlertModalButton
              className="confirmation-modal_tertiary-button"
              variant="tertiary"
              onClick={handleTertiary(activeModal.id)}
            >
              {activeModal.tertiaryText}
            </AlertModalButton>
          </AlertModalFooter>
        )}
        <AlertModalFooter aligner side="right">
          {!activeModal.hideCancelButton && (
            <AlertModalButton
              className="confirmation-modal_cancel-button bcl-ignore-click-outside"
              variant="secondary"
              onClick={handleCancel(activeModal.id)}
            >
              {activeModal.cancelText}
            </AlertModalButton>
          )}
          <AlertModalButton
            className="confirmation-modal_ok-button bcl-ignore-click-outside"
            variant="primary"
            onClick={handleOk(activeModal.id)}
          >
            {activeModal.okText}
          </AlertModalButton>
        </AlertModalFooter>
      </AlertModalFooter>
    </AlertModal>
  );
};
